import React, { Component } from 'react';
import Weight from './healthRisksTabs/Weight'
import { Breadcrumb, Row, Tabs, Col, Card, Avatar, notification, Spin, List, message, Progress, Tag, Icon, Button} from 'antd';
import InfiniteScroll from 'react-infinite-scroller';
import {LeftChevronIcon,RightChevronIcon,TrendsIcon} from '../../assets/images';
const { Meta } = Card;
const TabPane = Tabs.TabPane;

class HealthChecks extends Component {
  constructor(props) {
      super(props);
      this.state = {
        data: {},
        keys: [],
        employees_non_sponsored_checks: 0,
        dependents_non_sponsored_checks: 0,
        dep_less_than_50: [],
        dep_more_than_50: [],
        loc_less_than_50: [],
        loc_more_than_50: []
      };
  }

  componentDidMount () {
    let that = this;
    this.setState({loading: true})
    window.axios.get(window.API_URL + 'corporate/health_checks')
      .then(function (response) {
        if (new Date().getMonth() + 1 <= 3){
          let next_year = new Date().getFullYear() + 1
          let fin_year = new Date().getFullYear() + '-' + next_year
          delete response.data[0]["json_object_agg"][fin_year]
        }
        that.setState({keys: Object.keys(response.data[0]['json_object_agg']), 
                       data: response.data,loading: false})
      })
      .catch(function (error) {
        that.setState({loading: false})
        notification['error']({
        message: 'Something Went Wrong',
        description: "Please try again later"
        })
        console.log(error);
      })
  }

  renderOverview(){
    sessionStorage.setItem('defaultSelectedTab', '9')
    this.props.history.push({pathname: '/overview'})
  }


  handleInfiniteOnLoad = (records) => {
    let data = records;
    this.setState({
      loading: true,
    });
    if (data.length > 14) {
      message.warning('Infinite List loaded all');
      this.setState({
        hasMore: false,
        loading: false,
      });
      return;
    }
    this.fetchData((res) => {
      data = data.concat(res.results);
      this.setState({
        data,
        loading: false,
      });
    });
  }

  renderCardName(value){
    return(
      <h5 className="sub-title">{value}</h5>
    )
  }

  renderCardDesc(value,color){
    return(
      <h2 className="main-numbers" style={{color: color,marginBottom: 0}}>{value}</h2>
    )
  }

  getColor(value){
    let color = '#ebebeb'
    if (value == 'Active') {
      color = '#0066fb'
    }else if(value == 'Low'){
      color = '#ffa928'
    }else if(value == 'Unavailable'){
      color = '#70411b'
    }
    return color
  }

  showHealthCheckTrends(){
    sessionStorage.setItem('defaultSelectedTab', '100')
    this.props.history.push({pathname: '/health-check-trends'}
                            )
  }

  renderDeptLocFilterPage(more_than_50,less_than_50,text,not_updated){
    let low_perc = '<50% Utilization'
    let high_perc = '>50% Utilization'
    let text_display = text === 'Locations' ? 'location' : 'department'
    return(
      <div>
        <Row>
          <Col span={12}>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,minHeight: 421}}>
              <Row>
                <Col span={12}>
                  <h3 className="font-semibold">High Utilization</h3>
                </Col>
                <Col span={12}>
                  <Row type="flex" justify="end">
                    <Tag className="high-utilization-tag">{high_perc}</Tag>
                  </Row> 
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <h5 style={{color: '#8c9197'}}>The {text} that are performing really well</h5>
                </Col>
              </Row>
              <div className="health-check-infinite-container">
                <InfiniteScroll
                  initialLoad={false}
                  pageStart={0}
                  loadMore={this.handleInfiniteOnLoad}
                  hasMore={!this.state.loading && this.state.hasMore}
                  useWindow={false}
                >
                  <List 
                    style={{border: '1px solid #F4F4F4'}}
                    dataSource={more_than_50}
                    renderItem={item => (
                      <List.Item style={{paddingLeft: 15, marginTop: 6,borderBottom: '1px solid #F4F4F4 !important'}}>

                        <List.Item.Meta
                          title={<h4 className="semibold">{Object.keys(item)}</h4>}
                          description={<div>
                                      { Object.keys(item)[0] === "Department Unavailable" || Object.keys(item)[0] === "Location Unavailable" ?
                                      <svg height="10" width="100%" style={{paddingRight: 50}}>
                                        <rect x="0" y="5" width="100%" height="10" style={{fill: this.getColor("Default")}}/>
                                        <rect x="0" y="5" width={Object.values(item) + '%'} height="10" style={{fill: this.getColor("Unavailable")}}/>
                                      </svg>
                                      :
                                      <svg height="10" width="100%" style={{paddingRight: 50}}>
                                        <rect x="0" y="5" width="100%" height="10" style={{fill: this.getColor("Default")}}/>
                                        <rect x="0" y="5" width={Object.values(item) + '%'} height="10" style={{fill: this.getColor("Active")}}/>
                                      </svg>
                                      }
                                      <Row type="flex" justify="end" style={{marginTop: '-20px',marginRight: 10}}>
                                        <h4 className="semibold" style={{color: '#757575'}}>{Object.values(item)}%</h4>
                                      </Row></div>}
                        />
                      </List.Item>

                    )}
                  >
                    {this.state.loading && this.state.hasMore && (
                      <div className="health-check-loading-container">
                        <Spin />
                      </div>
                    )}
                  </List>
                </InfiniteScroll>
              </div>
            </Card>
          </Col>
          <Col span={12} style={{paddingLeft: 12}}>
            <Card className="health-check-utilization-card" style={{minHeight: 421}}>
              <Row>
                <Col span={12}>
                  <Row type="flex" justify="start">
                    <h3 className="font-semibold">Low Utilization</h3>
                  </Row> 
                </Col>
                <Col span={12}>
                  <Row type="flex" justify="end">
                    <Tag className="low-utilization-tag">{low_perc}</Tag>
                  </Row> 
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <h5 style={{color: '#8c9197'}}>The {text} that not performing upto the mark</h5>
                </Col>
              </Row>
              <div className="health-check-infinite-container">
                <InfiniteScroll
                  initialLoad={false}
                  pageStart={0}
                  loadMore={this.handleInfiniteOnLoad}
                  hasMore={!this.state.loading && this.state.hasMore}
                  useWindow={false}
                >
                  <List 
                    style={{border: '1px solid #F4F4F4'}}
                    dataSource={less_than_50}
                    renderItem={item => (
                      <List.Item style={{paddingLeft: 15, marginTop: 6,borderBottom: '1px solid #F4F4F4 !important'}}>

                        <List.Item.Meta
                          title={<h4 className="semibold">{Object.keys(item)}</h4>}
                          description={<div>
                                      { Object.keys(item)[0] === "Department Unavailable" || Object.keys(item)[0] === "Location Unavailable" ?
                                      <svg height="10" width="100%" style={{paddingRight: 50}}>
                                        <rect x="0" y="5" width="100%" height="10" style={{fill: this.getColor("Default")}}/>
                                        <rect x="0" y="5" width={Object.values(item) + '%'} height="10" style={{fill: this.getColor("Unavailable")}}/>
                                      </svg>
                                      :
                                      <svg height="10" width="100%" style={{paddingRight: 50}}>
                                        <rect x="0" y="5" width="100%" height="10" style={{fill: this.getColor("Default")}}/>
                                        <rect x="0" y="5" width={Object.values(item) + '%'} height="10" style={{fill: this.getColor("Low")}}/>
                                      </svg>
                                      }
                                      <Row type="flex" justify="end" style={{marginTop: '-20px',marginRight: 10}}>
                                        <h4 className="semibold" style={{color: '#757575'}}>{Object.values(item)}%</h4>
                                      </Row></div>}
                        />
                      </List.Item>

                    )}
                  >
                    {this.state.loading && this.state.hasMore && (
                      <div className="health-check-loading-container">
                        <Spin />
                      </div>
                    )}
                  </List>
                </InfiniteScroll>
              </div>
            </Card>
            
          </Col>
        </Row>
        <Row type="flex" justify="start">
          <h5 className="health-check-note"><Icon type="info-circle" theme="filled" style={{color: '#70411b'}}/>&nbsp;Employees who haven’t provided {text_display} : <span className="semibold">{not_updated}</span></h5>
        </Row>
      </div>
    )
  }
  renderHealthCheckAnalysisPage(key_value){
    let that = this
    let record = JSON.parse(that.state.data[0]["json_object_agg"][key_value])
    that.state.employees_non_sponsored_checks = record.employees_non_sponsored_checks
    return(
      <div>
        <Row style={{marginTop: 60}}>
          <Col span={12}>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,height: 260}}>
              <Row style={{marginBottom: 80}}>
                <Col span={10} style={{borderRight: '1px solid #d3dbe6'}}>
                  <Row type="flex" justify="start">
                    <h5 className="sub-title">COMPLETED CHECKS</h5>
                  </Row>
                  <Row type="flex" justify="start">
                    <h2 className="main-numbers" style={{color: '#0066fb'}}>{record.employees}&nbsp;<span style={{color: '#9b9b9b'}}>Employees</span></h2>
                  </Row>
                  <Row type="flex" justify="start" className="mt-minus-12">
                    <h6 className="number-sub-title"><span style={{color: '#4d6189',fontFamily: 'ProximaNova-Semibold'}}>{(record.employees*100/record.total_emp).toFixed(1) + '%'}</span>&nbsp;of&nbsp;<span style={{color: '#9b9b9b',fontFamily: 'ProximaNova-Semibold'}}>{record.total_emp}</span></h6>
                  </Row>
                </Col>
                <Col span={14} style={{paddingLeft: 70}}>
                  <Row type="flex" justify="start">
                    <h5 className="sub-title">YET TO UTILIZE</h5>
                  </Row>
                  <Row type="flex" justify="start">
                    <h2 className="main-numbers" style={{color: '#c80010'}}>{record.not_utilized}&nbsp;<span style={{color: '#9b9b9b'}}>Employees</span></h2>
                  </Row>
                </Col>
              </Row>
              <Row className="footer-card">
                <Row type="flex" justify="start" style={{marginTop: 12,marginLeft: 24}}>
                  <h4 className="font-semibold">Increase Health Checks Utilization</h4>
                </Row>
                <Row type="flex" justify="start" style={{marginTop: 3,marginLeft: 24,marginBottom: 6}}>
                  <h5 className="zero-state-body-text" style={{marginTop: '-10'}}>Reach out to your customer success manager <span className="semibold" style={{color: '#2168f3'}}>{sessionStorage.getItem('hr_contact_email')}</span> to know how you can increase the health checks</h5>
                </Row>
              </Row>
            </Card>
          </Col>
          <Col span={12} style={{paddingLeft:12}}>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,height: 120}}>
              <Row type="flex" justify="start">
                <img className="mt-minus-2" src="https://res.cloudinary.com/ekincare/image/upload/v1560837069/hr_dashboard_overview/Health_Checks.svg" style={{width: 20,height: 20}}/>
                <h5 className="sub-title" style={{marginLeft: 2}}>DEPENDENT WHO TOOK</h5>
              </Row>
              <Row style={{marginTop: 12}}>
                <Col span={12} style={{borderRight: '1px solid #d3dbe6',height: 50}}>
                  <Row type="flex" justify="start">
                    <h6 className="number-sub-title">No. of Dependents</h6>
                  </Row>
                  <Row type="flex" justify="start" style={{marginTop: '-10px'}}>
                    <h2 className="main-numbers">{record.dependents}</h2>
                  </Row>
                </Col>
                <Col span={12} style={{paddingLeft: 70}}>
                  <Row type="flex" justify="start">
                    <h6 className="number-sub-title">Completed Health Checks</h6>
                  </Row>
                  <Row type="flex" justify="start" style={{marginTop: '-10px'}}>
                    <h2 className="main-numbers">{record.dependent_health_checks}</h2>
                  </Row>
                </Col>
              </Row>
            </Card>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,height: 120}}>
              <Row type="flex" justify="start">
                <img className="mt-minus-2" src="https://res.cloudinary.com/ekincare/image/upload/v1560837069/hr_dashboard_overview/Health_Checks.svg" style={{width: 20,height: 20}}/>
                <h5 className="sub-title" style={{marginLeft: 2}}>DIGITIZED REPORTS FROM HEALTH CHECKS</h5>
              </Row>
              <Row style={{marginTop: 12}}>
                <Col span={12}>
                  <Row type="flex" justify="start" style={{marginTop: '-10px'}}>
                    <h2 className="main-numbers">{record.total_reports}</h2>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Card className="health-check-utilization-card" style={{marginRight: 10,marginBottom: 20}}>

              <Meta
                avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1562910228/hr_dashboard_overview/user-03-a-copy-3.svg" />}
                title={this.renderCardName("BENEFIT TO EMPLOYEES")}
                description={this.renderCardDesc("\u20B9" + (record.employee_benefits).toFixed(1).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,').replace('.0',''),'#9b9b9b')}
              />
              
            </Card>
          </Col>
          <Col span={8}>
            <Card className="health-check-utilization-card" style={{marginRight: 10,marginBottom: 20}}>
              <Meta
                avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1562910228/hr_dashboard_overview/user-03-a-copy-3.svg" />}
                title={this.renderCardName("BENEFIT TO DEPENDENTS")}
                description={this.renderCardDesc("\u20B9" + (record.dependent_benefits).toFixed(1).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,').replace('.0',''),'#9b9b9b')}
              />
            </Card>
          </Col>
          <Col span={8}>
            <Card className="health-check-utilization-card" style={{marginBottom: 20}}>
              <Meta
                avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1562911336/hr_dashboard_overview/group-2.svg" />}
                title={this.renderCardName("SAVINGS BY EKINCARE")}
                description={this.renderCardDesc("\u20B9" + (record.ekincare_saved).toFixed(1).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,').replace('.0',''),'#000000')}
              />
            </Card>
          </Col>
        </Row>
        <Row style={{marginTop: 60}}>
        <Col span={24}>
            <Row type="flex" justify="start" style={{marginLeft: 5}}>
              <h4 className="sub-heading-title" style={{color: '#8c9197'}}>UTILIZATION ACROSS</h4>
            </Row>
            <Tabs defaultActiveKey="4" >
              <TabPane tab="Departments" key="4">
                {this.renderDeptLocFilterPage(record.dep_more_than_50 ? record.dep_more_than_50 : [],record.dep_less_than_50 ? record.dep_less_than_50 : [],'Departments',record.no_department)}
              </TabPane>
              <TabPane tab="Locations" key="5">
                {this.renderDeptLocFilterPage(record.loc_more_than_50 ? record.loc_more_than_50 : [],record.loc_less_than_50 ? record.loc_less_than_50 : [],'Locations',record.no_location)}
              </TabPane>
            </Tabs>  
          </Col>  
        </Row>
      </div>
    )
  }


  render () {
    let that = this
    const overviewLoading   = this.state.loading
    console.log(this.state)
    return(
      <div>
      {that.state.loading? <div className="spiner">
          <Spin size="large"/>
        </div> :
      <div>
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start">
              <a style={{marginTop: 10}} className="flex flex-row w-full mb-2 items-center" onClick={this.renderOverview.bind(this)}><img className="mt-minus-4 chevronBackLink" style={{marginRight: 5}} src={LeftChevronIcon} /> <span className="GoBackLink" >Go Back</span></a>
            </Row>
          </Col>
        </Row> 
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start">
              <h2 className = 'main-heading' style={{fontSize: 26,marginBottom: '-6px'}}>Health Checks</h2>
            </Row>
            <Row type="flex" justify="start">
              <button className="flex w-1/3 flex-row just items-center bg-white justify-between py-2 border border-sm px-4 rounded-lg" onClick={this.showHealthCheckTrends.bind(this)} style={{color: '#4d6189',marginTop: 10}}><img src={TrendsIcon} style={{marginRight: 10}}/> Show Trends <img src={RightChevronIcon} style={{marginLeft: 10}}/></button>
            </Row>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end">
              <img src="https://res.cloudinary.com/ekincare/image/upload/v1562667722/hr_dashboard_overview/group-6.svg" />
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start" style={{marginLeft: 5}}>
              <img src="https://res.cloudinary.com/ekincare/image/upload/v1563267839/hr_dashboard_overview/group-4.svg"/>
              <h4 className="sub-heading-title" style={{color: '#8c9197',marginLeft: 5,marginTop:5}}>BASED ON FINANCIAL YEAR</h4>
            </Row>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end" style={{paddingRight: 5}}>
              <h4 className="top-right-delay-label" style={{marginTop: 4}}>Refreshes every <b> 1 hour </b></h4>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Tabs
              defaultActiveKey="0"
            >
              {this.state.keys.map((key,index) => (
                <TabPane tab={key === '0_overall' ?  "Overall Data" : key} key={index}>
                  {this.renderHealthCheckAnalysisPage(key)}
                </TabPane>
              ))}
            </Tabs>
               
          </Col>
        </Row>  
      </div>
      }
      </div>
    )
  }    
}
export default HealthChecks;